import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-category',
	templateUrl: './category.component.html',
	styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
	categoryForm: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	modalTitle: any;
	categoryList: any;
	btnTitle: any;
	selectedCategoryId: any;
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	category: any;
	categoryLan:any  = [];

	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }

	ngOnInit() {
		//this.commonService.setTitle();
		$(".navbar-brand").text("Category");
		this.categoryForm = new FormGroup({
			category: new FormControl("", Validators.compose([Validators.required])),
			category_arabic: new FormControl("", Validators.compose([null])),
			category_hindi: new FormControl("", Validators.compose([null])),
			category_latin: new FormControl("", Validators.compose([null])),
			category_french: new FormControl("", Validators.compose([null])),
		});
		this.limit = 10;
		this.getCategoryList(1, this.limit);
	}

	// Get category List
	getCategoryList = function (pageNo, limit) {
		this.commonService.process();
		this.authService.getSurveyCategoryList(pageNo, limit).subscribe(data => {
			if (data.success) {
				this.categoryList = data.category;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.categoryList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getCategoryList(page, this.limit);
		}
	}

	// addCategory
	addCategory = function () {
		this.isActivatedAdd = true;
		this.isActivatedEdit = false;
		this.isActivatedDelete = false;
		this.modalTitle = "Add Category";
		this.btnTitle = "Save";
		this.selectedCategoryId = "";
		this.categoryForm.reset();
	}

	// Update selected category
	updateSelectedCategory = function (category) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = true;
		this.isActivatedDelete = false;
		this.modalTitle = "Update Category";
		this.btnTitle = "Update";
		this.selectedCategoryId = category._id;
		this.categoryForm.controls['category'].setValue(category.category);

		this.authService.getSingleCategory(this.selectedCategoryId).subscribe(data => {
			if (data.success) {
				console.log(data.result);
				this.categoryForm.controls['category_arabic'].setValue(data.result.category_arabic);
				this.categoryForm.controls['category_hindi'].setValue(data.result.category_hindi);
				this.categoryForm.controls['category_latin'].setValue(data.result.category_latin);
				this.categoryForm.controls['category_french'].setValue(data.result.category_french);
			}
		});

		console.log(category);
	}

	// Delete Selected Category
	deleteSelectedCategory = function (category) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete Category";
		this.btnTitle = "Yes";
		this.selectedCategoryId = category._id;
		this.category = category;

	}

	viewLanguageCategory = function (category){
		this.categoryLan = category.category_language ? category.category_language : [];
	}

	// manage new category
	manageCategory = function (category) {

		if (this.categoryForm.valid && this.isActivatedAdd) {
			this.btnTitle = "Saving...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			console.log(category);
			
			this.authService.manageCategory(category, "add").subscribe(data => {
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.getCategoryList(1, this.limit);
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		} else if (this.categoryForm.valid && this.isActivatedEdit) {
			category._id = this.selectedCategoryId;
			this.btnTitle = "Updating...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageCategory(category, "update").subscribe(data => {
				if (data.success) {
					this.getCategoryList(this.pageNo, this.limit);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		} else if (this.isActivatedDelete) {
			category._id = this.selectedCategoryId;
			this.btnTitle = "Deleting...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageCategory(category, "delete").subscribe(data => {
				if (data.success) {
					this.getCategoryList(1, this.limit);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.categoryForm);
		}
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/category/category.component.ts